/* eslint-disable import/no-unresolved */
import CustomTextField from "src/shared/CustomTextField";

interface Props {
  formik: any;
}

function AddressDetails({ formik }: Props) {
  return (
    <div>
      <p className="text-daintree font-montserrat text-sm font-medium mb-6">
        Your full address in the country of your residence
      </p>
      <div className="md:w-741/1000">
        <CustomTextField
          requiredStar
          label="Your full address in the country of your residence"
          className=""
          // onChange={handleChange("residence.nameOfTheBankResidence")}
          onChange={formik.handleChange}
          handleBlur={formik.handleBlur}
          value={formik.values.residence?.nameOfTheBankResidence}
          name="residence.nameOfTheBankResidence"
          error={formik.errors.residence?.nameOfTheBankResidence}
          touched={formik.touched.residence?.nameOfTheBankResidence}
        />
      </div>
    </div>
  );
}

export default AddressDetails;
